import {
    useMemo,
} from 'react'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useGetLaneGroup from 'app/Apps/Pricing/LaneGroups/hooks/useGetLaneGroup'
import {
    DeliveryServiceType,
    TransportModeRoad,
} from 'app/enums/label.enums'
import useEnumValues from 'app/hooks/useEnumValues'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'

import getFields, {
    LaneGroupInformationFormFields,
} from './LaneGroupInformationForm.fields'

export default function LaneGroupInformationForm({
    id,
    update,
    disabled = false,
    contractId,
}: Readonly<{
    id?: number,
    update?: (value: LaneGroupInformationFormFields) => void,
    disabled?: boolean,
    contractId: number
}>) {
    const getAllowedValues = useEnumValues()
    const {
        LaneGroups: LaneGroupsRoutes,
    } = usePricingRoutes()

    const {
        data: laneGroup,
        isDataReady,
    } = useGetLaneGroup(id)

    const value = useMemo(() => {
        if (isDataReady) {
            return {
                ...laneGroup,
                laneGroup: {
                    id: laneGroup.id,
                },
            }
        }
        return null
    }, [
        laneGroup,
        isDataReady,
    ])

    const fields = useMemo(() => {
        return getFields({
            disabled,
            getAllowedValues,
            usePositioningTemperature: {
                showFTL: [
                    TransportModeRoad.FTL,
                    TransportModeRoad.FTL_OR_LTL,
                ].includes(value?.transportModeRoad),
                showLTL: [
                    TransportModeRoad.LTL,
                    TransportModeRoad.FTL_OR_LTL,
                ].includes(value?.transportModeRoad),
            },
            contractId,
            useTransportModeRoad: value?.deliveryServiceType === DeliveryServiceType.DELIVERY_ROAD,
            generateLaneGroupLink: (laneGroupId: number | string) => {
                if (!laneGroupId) return null
                return generateSkyNetLink({
                    domainPath: LaneGroupsRoutes.Overview.path,
                    params: {
                        key: laneGroupId,
                    },
                })
            },
        })
    }, [
        LaneGroupsRoutes.Overview.path,
        contractId,
        disabled,
        getAllowedValues,
        value?.deliveryServiceType,
        value?.transportModeRoad,
    ])

    return (
        <DomainObjectForm
            name="LaneGroupInformationForm"
            value={value}
            fields={fields}
            onChange={update}
        />
    )
}
